
import { Vue, Component } from 'nuxt-property-decorator'

const env: string = process.env.APP_ENV as string || ''

@Component
export default class DevMark extends Vue {
  environment = '';

  mounted (): void {
    switch (env) {
    case 'development':
      this.environment = '開発環境(development)'
      break
    case 'staging':
      this.environment = '検証環境(staging)'
      break
    }
  }
}
